import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'elbuild-ui-componentslib';
import { MessageService } from 'elbuild-ui-lib-core';
import { ConsultantResource, ConsultantResourceService, PresenceUpdate } from 'toolbandi-ui-lib';

@Component({
	selector: 'app-consultantresource-presenceupdate',
	templateUrl: './consultantresource-presenceupdate.component.html',
	styleUrls: ['./consultantresource-presenceupdate.component.scss']
})
export class ConsultantresourcePresenceupdateComponent implements OnInit {

	@Input() consultantresource: ConsultantResource;

	start: Date;
	stop: Date;
	presenceupdate: PresenceUpdate;

	edited: boolean = false;
	loading: boolean;
	direction: 'prev' | 'next' = undefined;

	constructor(
		private consultantresourceService: ConsultantResourceService,
		private messageService: MessageService,
		private dialogService: DialogService,
		private translateService: TranslateService,
		private modalService: NgbModal
		) {
			this.start = new Date();
			this.start.setDate(this.start.getDate() + (1 + 7 - this.start.getDay()) % 7 - 7);
			this.stop = new Date();
			this.stop.setDate(this.start.getDate() + 7);


			console.log(this.start, this.stop);
		}

		ngOnInit(): void {

			if (this.consultantresource) {
				this.loadConsultantresourceMatrix();
			}

		}

		prev(content: any): void {
			this.direction = 'prev';
			if (this.edited) {
				this.askSave(content);

			} else {
				this.start.setDate(this.start.getDate() - 7);
				this.stop.setDate(this.stop.getDate() - 7);

				this.loadConsultantresourceMatrix();
			}

		}

		askSave(content: any): void {
			this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });

		}

		move() {
			this.modalService.dismissAll();
			switch (this.direction) {
				case 'prev':
				this.prev(null);
				break;
				case 'next':
				this.next(null);
				break;
			}
		}

		moveWithoutSave(): void {
			this.edited = false;
			this.move();
		}

		next(content: any): void {
			this.direction = 'next';
			if (this.edited && content) {
				this.askSave(content);
			} else {
				this.start.setDate(this.start.getDate() + 7);
				this.stop.setDate(this.stop.getDate() + 7);

				this.loadConsultantresourceMatrix();
			}
		}


		loadConsultantresourceMatrix(): void {
			this.loading = true;
			this.consultantresourceService.getConsultantResourceHourmatrix(this.consultantresource.id, this.START, this.STOP).subscribe((data: PresenceUpdate) => {
				this.presenceupdate = data;
				this.loading = false;
				this.edited = false;
				this.direction = undefined;
				console.log(this.presenceupdate);

			}, ({ error }) => {
				this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
				this.loading = false;
			});
		}

		get START(): number {
			return Math.floor(this.start.getTime() / 1000);
		}

		get STOP(): number {
			return Math.floor(this.stop.getTime() / 1000);
		}

		save(): void {
			this.consultantresourceService.saveConsultantResourceHourmatrix(this.consultantresource.id, this.presenceupdate).subscribe((data: PresenceUpdate) => {

				if (this.direction) {
					this.edited = false;
					this.move();
				} else {
					this.loadConsultantresourceMatrix();
				}
			}, ({ error }) => {
				this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
				this.loading = false;
			});


		}

		cancel(): void {
			this.loadConsultantresourceMatrix();
		}

		dismiss(): void {
			this.modalService.dismissAll();
		}


	}

